import React from "react"
import { func, string, boolean, array } from "prop-types"

import Button from "shared/components/Button/Button"
import Modal from "shared/components/ModernModal/index"
import { EmptyStatePIX } from "assets/svg/index"

import Typograph from "components/Typograph"
import styles from "./styles.css"

const ModalError = ({
  onClose,
  title,
  messageError,
  isOpen,
  failedInvoices
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} renderFooter={false}>
      <Typograph
        htmlTag="p"
        preset="p"
        size="medium"
        color="outer_space"
        weight="bold"
      >
        {title}
      </Typograph>
      {!failedInvoices ? (
        <div>
          <img
            className={styles.imageModalError}
            src={EmptyStatePIX}
            alt="Ilustração de uma pessoa montando uma tela de erro, com um grande botão 'x' verde."
          />
          <Typograph
            htmlTag="p"
            preset="p"
            size="medium"
            color="outer_space"
            weight="medium"
          >
            <Typograph htmlTag="span" size="medium" weight="medium">
              {messageError}
            </Typograph>
          </Typograph>
        </div>
      ) : (
        <div className={styles.failedInvoices}>
          {failedInvoices.map((item) => (
            <div key={item.invoiceId}>
              <Typograph htmlTag="span" size="medium" weight="medium">
                Fatura: {item.invoiceId} - Conta de Faturamento:{" "}
                {item.billingAccount}
              </Typograph>
            </div>
          ))}
        </div>
      )}
      <div className={styles.btnModalError}>
        <Button onClick={() => onClose()} width="small">
          Sair
        </Button>
      </div>
    </Modal>
  )
}

ModalError.propTypes = {
  onClose: func,
  title: string,
  messageError: string,
  isOpen: boolean,
  failedInvoices: array
}

export default ModalError



// WEBPACK FOOTER //
// ./src/components/ModalError/index.js